<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nKEQgi/tc-custom/9780316346849.jpg?1733082396370" alt="This image is the cover for the book Talking Dirty, Pax Arcana"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Talking Dirty, Pax Arcana
      </h1>
      <p class="bookDescription body article font2">
        <b>John Charming. Ex knight. Current monster hunter.</b><br/><br/>While trying to deal with a monster he can't bring himself to kill, John Charming soon runs into another problem: Magic and technology don't mix. . .so how is a phone sex operation enchanting men through their cell phones?<br/><br/>This is a short story from contemporary fantasy author, Elliott James, within his Pax Arcana world. The first of his novels, <i>Charming </i>and <i>Daring</i>, are available now.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elliott James
      </h2>
      
      <p class="authorDescription body article">An army brat and gypsy scholar, <B>Elliott James</B> is currently living in the Blue Ridge mountains of southwest Virginia. An avid reader since the age of three (or that's what his family swears anyhow), he has an abiding interest in mythology, martial arts, live music, hiking, and used bookstores.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Orbit
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d4f1fd54